import { formatThousands } from '../../../utils/format/formatNumber';
import * as S from './ReportItem.style';
export default function ReportItem({ item, value }) {
    const { label, id } = item;
    return (
        <S.ReportItemLi>
            <S.ReportVariant>
                <S.ColorChip $id={id} />
                {label}
            </S.ReportVariant>
            <S.DiffValue $id={id}>{formatThousands(value) || 0}</S.DiffValue>
        </S.ReportItemLi>
    );
}
